@if (list && list.length > 0) {
  <span class="filter-title" [ngClass]="{ 'd-none': filterValues.includes('separator') }">{{ name | titlecase }}</span>
}

<ul class="multi-select">
  <!-- Track by $index: option.value would be ideal but FEAT_BLANQUEANTE is duplicated (and a bit buggy) in Spain.-->
  @for (option of list; track $index) {
    <li>
      @if (isSeparator(option.value)) {
        <div>
          <span class="filter-title">{{ option.label }}</span>
        </div>
      }
      @if (!isSeparator(option.value)) {
        <div class="multi-select__item">
          <div class="form-check" [ngClass]="{ active: option.checked }">
            <input
              type="checkbox"
              name="filter"
              class="form-check__input"
              [id]="option.value"
              [(ngModel)]="option.checked"
              (change)="getSelectedValue(option)"
            />
            <label class="form-check__label" [for]="option.value">
              <span>{{ option.label }}</span>
            </label>
          </div>
        </div>
      }
    </li>
  }
</ul>
